import { blacklistedVendors } from 'constants/refundRequests'
import getHotelCancellationConfig from './getHotelCancellationConfig'
import moment from 'moment'

interface RefundRequestOptions {
  /**
   * Ignores whether or not insurance (and refund protect) affect the
   * availability of the call
   **/
  ignoreInsurance?: boolean;
}

export function itemCanRequestRefund(item: App.OrderItem, order: App.Order, options: RefundRequestOptions = {}) {
  const cancellationConfig = getHotelCancellationConfig(item, order)

  // only support flash hotels at the moment, LPC hotels don't have the same
  // relationship at the moment to use the refund request portal
  return item.offer.type === 'hotel' &&
    // order cannot have experiences or flights - we don't support
    // the interaction between these items and a refund request isn't set yet
    order.experienceItems.length === 0 &&
    order.transferItems.length === 0 &&
    order.flightItems.length === 0 &&
    // don't want certain vendors to access this
    !blacklistedVendors.has(item.vendorId) &&
    // can't already be refunded
    !order.refunds.some(refund => refund.itemId === item.id) &&
    // can't already be cancelled
    item.status !== 'cancelled' &&
    // no existing refund requests
    !order.refundRequests[item.id] &&
    // The cancellation policy allows requesting refunds
    cancellationConfig.canRequestRefund &&
    // don't need to make a refund request if they can *actually* refund!
    !cancellationConfig.canRefund &&
    // Don't need a refund request if they can use booking protection
    (options.ignoreInsurance || !cancellationConfig.canUseBookingProtection)
}

export function canRefundItem(item: App.OrderItem, order: App.Order) {
  const cancellationConfig = getHotelCancellationConfig(item, order)

  // can't refund a cancelled item
  return item.status !== 'cancelled' &&
  // can't already have a refund
  !order.refunds.some(refund => refund.itemId === item.id) &&
  // can't have a refund request against it
  !order.refundRequests[item.id] &&
  (
    // cancellation policy must allow it or they have insurance to allow it
    cancellationConfig.canRefund ||
    cancellationConfig.canUseBookingProtection ||
    cancellationConfig.canUseCancellationProtection
  )
}

export function isItemRefundRequestPastDeadline(item: App.OrderItem) {
  // deadline for receiving a refund for refund requests is 3 days prior to check in
  const deadline = moment(item.reservation?.startDate).subtract(3, 'days')
  return moment().isAfter(deadline)
}

export function canRefundCarHireItem(item: App.CarHireOrderItem, order: App.Order, cancellationPolicies: App.CarHireCancellationPolicy) {
  // can't refund a cancelled item
  return item.status !== 'cancelled' &&
  // can't already have a refund
  !order.refunds.some(refund => refund.itemId === item.id) &&
  moment().isBefore(moment(cancellationPolicies.maxDate))
}
